import { useNavigate, useParams } from "react-router";
import { useSamplesSurfaceMicrobialBaseDataShowQuery } from "@/services/backend/samples/api/surface-microbial-base-data-api";
import { SurfaceMicrobialBaseDataFields } from "@/services/backend/samples/components/surface-microbial-base-data-fields";
import { DeleteSurfaceMicrobialBaseDataDialog } from "@/services/backend/samples/components/delete-surface-microbial-base-data-dialog";
import { SampleBaseDataDetailCard } from "@/routes/base-data/samples/_components/sample-base-data-detail-card";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";

export function SurfaceMicrobialBaseDataRoute() {
  const { baseDataId } = useParams();
  const navigate = useNavigate();

  const {
    data: baseData,
    isLoading,
    error,
  } = useSamplesSurfaceMicrobialBaseDataShowQuery({ id: baseDataId! });

  return (
    <PersistenceContextProvider>
      <SampleBaseDataDetailCard
        baseData={baseData}
        isLoading={isLoading}
        error={error}
        actions={
          baseData && (
            <DeleteSurfaceMicrobialBaseDataDialog
              baseData={baseData}
              onDeleted={() => navigate("..")}
            />
          )
        }
      >
        {baseData && <SurfaceMicrobialBaseDataFields id={baseData.id} />}
      </SampleBaseDataDetailCard>
    </PersistenceContextProvider>
  );
}
